// extracted by mini-css-extract-plugin
export default {"CardOverlay":"styles_CardOverlay__kbqaA","CardOverlayLogo":"styles_CardOverlayLogo__ULJpi","cardTitle":"styles_cardTitle__dLIYS"};